import {
    ClickoutTarget,
    PostPersistenceModel,
    ProductItemModel,
} from '../../data-layer/posts/types';
import type { PostPersistenceUI } from '../../ui/posts/types';

export const toPostPersistenceModel = (
    ui: PostPersistenceUI,
    productsDraft: ProductItemModel[],
): PostPersistenceModel => ({
    id: ui.id,
    businessId: ui.businessId,
    text: ui.text,
    media: ui.media,
    status: ui.status,
    clickouts: ui.site
        ? [
              {
                  url: ui.site,
                  urlDisplay: ui.site,
                  text: 'На сайт',
                  target: ClickoutTarget.BUTTON,
              },
          ]
        : [],
    productIds: productsDraft.map((productDraft) => productDraft.id),
    needCpaRegistration: ui.needCpaRegistration,
    isAIContent: ui.isAIContent,
});
